import styles from "./pagebreadcrumb.module.css";
import { Link } from "../link";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import SeoSchema from "../seo-schema/seo-schema";

type BreadcrumbProps = {
  isInHero?: boolean;
  isArticle?: boolean;
  items: any[];
  theme?: "light" | "dark";
};

type SchemaList = {
    "@type": string;
    "position": number;
    "name": string;
    "item": string;

}

export const PageBreadcrumb = (props: BreadcrumbProps) => {
  console.log("Breadcrumb Component items", props);
  const items: any[] = props.items || [];
  const isInHero = props.isInHero || false;
  const theme = props.theme || "light";
  const isArticle = props.isArticle || false;

  const ellipses = {
    active: false,
    link: {
      url: "#",
    },
    title: "...",
  };

  const lessItems = [...items];
  if (lessItems.length > 3) {
    lessItems.splice(1, lessItems.length - 3, ellipses);
  }

  const [displayItems, setDisplayItems] = useState(lessItems);
  const [breadcrumbSchema, setBreadcrumbSchema] = useState<string | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    setDisplayItems(items);
  };

  const truncateTitle = (title: string) => {
    if (title.length > 20) {
      return `${title.slice(0, 20)}...`;
    } else {
      return title;
    }
  };

  useEffect(() => {
    console.log('displayItems', displayItems);
    const itemListElement:SchemaList[] = [];
    if(displayItems.length > 0) {
      displayItems.forEach((d, i) => {
        itemListElement.push(
          {
          "@type": "ListItem",
          "position": i + 1,
          "name": d.title,
          "item": `${window.location.origin}${d.link.url}`
        })
      })
    }
    const schema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": itemListElement
    }
    setBreadcrumbSchema(JSON.stringify(schema))
}, [displayItems]);

    return (
        <nav
            className={clsx(
                {defaultLayoutOuter: !isInHero},
                styles["breadcrumbContainer"],
                {
                    [styles["heroBreadcrumbContainer"] as string]: isInHero,
                    [styles["dark"] as string]: theme === "dark",
                    [styles["light"] as string]: theme === "light"
                },
            )}
        >
            <div className={clsx({defaultGrid: isArticle})}>
              {breadcrumbSchema && (
                <SeoSchema data={{ "jsonSchema": breadcrumbSchema, optionType:"static"}}/>
              )}
                <ul className={clsx({[styles['articleBreadcrumbContainer']]: isArticle})}>
                    {displayItems?.map((item, index) => (
                        <li key={index} className={item.active ? styles["active"] : ""}>
                            <Link
                                theme={theme}
                                size="xxsmall"
                                icon={index > 0 ? "chevronRight" : undefined}
                                href={item.active ? undefined : item.link.url}
                                override="noDefaultUnderline"
                                onClick={
                                    item.title === "..." ? (event) => handleClick(event) : undefined
                                }
                            >
                                {item.active ? truncateTitle(item.title) : item.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </nav>
);
};
